import { render, staticRenderFns } from "./CrmHistory.vue?vue&type=template&id=787126a3"
import script from "./CrmHistory.vue?vue&type=script&lang=js"
export * from "./CrmHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports